<template>
  <div id="tabList">
    <div id="tabBox" class="clear">
      <Tabs :animated="false" type="card" :value="tapShow" @on-click="open" @on-tab-remove="tabDel" >
        <TabPane v-for="(tab,index) in tabList" :key="tab.name"  :closable="index!=0"  :name="tab.name"  :label="tab.title">
        </TabPane>
      </Tabs>
      <Dropdown id="tabDropDown" @on-click="handleTagsOption" trigger="click" style="position:absolute;">
        <Button type="primary" :size="buttonSize">
          {{$t('TabSelect')}} 
          <Icon type="arrow-down-b"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="clearAll">{{$t('clearAll')}}</DropdownItem>
          <DropdownItem name="clearOthers">{{$t('clearOthers')}}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>

    <!-- <router-view></router-view> -->
    <!--使用keep-alive会将页面缓存-->
    <keep-alive :include="cacheVue"><router-view></router-view></keep-alive> 
  </div>
</template>

<script>
export default {
  name: 'TagList',
  data () {
    return {
      m_dis: "≣",
      buttonSize:'large',
      cacheVue:[]
    }
  },
  methods: {
    open: function (name) {
      this.$router.push('/' + name)
      this.$store.commit('tabSwitch', name)
      if (name === 'indexw') {
        if (document.querySelector('.ivu-menu-item-active')) {
          Array.prototype.some.call(document.querySelector('.ivu-menu-item-active').children, (item) => {
            if (item.classList.contains('ivu-menu')) {
              item.style.display = 'none'
            }
          })
        }
      }
    },
    tabDel: function (name, index) {
      this.$store.commit('tabClose', name)
    },
    handleTagsOption (type) {
      if (type === 'clearAll') {
        this.$store.commit('clearAllTags')
        // this.tapShow = 'index'
      } else {
        this.$store.commit('clearOtherTags')
      }
    },
    toggleClick () {
       this.$emit('on-change')
    }
  },
//   beforeRouteEnter(to, from, next) {
//      console.log('beforeRouteEnter')
//      to.meta.keepAlive = true;
//      next();
//  },
  computed: {
    tapShow () {      // 获取打开的标签
    //   if (sessionStorage.getItem('tabShow') && sessionStorage.getItem('tabShow') !== 'undefined') {
    //     this.$store.state.tabOpen = sessionStorage.getItem('tabShow')
    //   }
      this.$router.push('/' + this.$store.state.tabOpen)
      return this.$store.state.tabOpen
    },
    //  beforeRouteLeave(to, from, next) {
    //      // 设置下一个路由的 meta
    //     to.meta.keepAlive = true;  // B 跳转到 A 时，让 A 缓存，即不刷新
    //     next();
    // },
    tabList () {     
      var list = this.$store.state.tagList;
      var tabList = [];
      this.cacheVue = [];
      for (var val of list) {  
        console.log(val)                  
        var title = this.$t('tab.' + val)
        tabList.push({name: val, title: title});
        this.cacheVue.push(val);
      }
      return tabList
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" type=text/less>
#tabList{
  margin:5px;
  width:e("calc(100% - 10px)");
  height:100%;
  .tagOptions:hover{
    .btnList{
      display:block;
    }
  }
  #tabBox{
    .ivu-tabs{
      width:e("calc(100% - 100px)");
      float: left;
    }
    .ivu-dropdown-item{
      width:100%;
      text-align:center;
      height:30px;
      line-height:30px;
      padding: 0;
    }
  }
  .ivu-btn-primary {
    color: #fff;
    border-color: #2d8cf0; 
    background-color: #017aff;
}
  .clear:after{
    content:'';
    display:block;
    clear:both;
    height:0;
    overflow:hidden;
    visibility:hidden;}
  .clear{
    zoom:1;
  }
  .ivu-tabs-content{
    height:e("calc(100% - 48px)");
  }
}
#tabDropDown {
  .ivu-select-dropdown{
    z-index: 2000 !important;
  }
}
.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
    margin: 0;
    margin-right: 4px;
    height: 31px;
    padding: 5px 16px 4px;
    border: 1px solid #dcdee2;
    border-bottom: 0;
    border-radius: 4px 4px 0 0;
    transition: all .3s ease-in-out;
    background: #f8f8f9;
    font-size: 14px;
    color: #333333;
}
.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
    height: 32px;
    padding-bottom: 5px;
    background: #fff;
    transform: translateZ(0);
    border-color: #dcdee2;
    color: #2d8cf0;
    font-size: 16px;
    background-color: #F5F5F9;
}
</style>



// WEBPACK FOOTER //
// src/components/public/tabs.vue